import { EventEmitter, Output, Component, OnInit, Input, ChangeDetectorRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges, OnDestroy, HostListener } from '@angular/core';
import { Table } from 'primeng/table';
import { Column, GridOption } from 'angular-slickgrid';
import * as moment from 'moment';
import { CueTableService } from './cue-table.service';
import { Utils } from '../../services/utils.service';
import { isNull } from '@angular/compiler/src/output/output_ast';

declare var Slick: any;

@Component({
  selector: 'app-cue-table',
  templateUrl: './cue-table.component.html',
  styleUrls: ['./cue-table.component.css'],
  providers: [CueTableService]
})
export class CueTableComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() columnDefinitions: Column[] = [];
  @Input() gridOptions: GridOption = {};
  @Input() dataset: any[] = [];
  @Input() callback: object;
  @Output() onSelectionChanges?: any = new EventEmitter();
  @Output() onTableCellClicked?: any = new EventEmitter();
  @Output() onTableRowDoubleClicked?: any = new EventEmitter();
  @Output() onTableCreated?: any = new EventEmitter();
  @Output() onDataViewCreated?: any = new EventEmitter();
  @Output() afterViewRendered?: any = new EventEmitter();
  @Output() afterGridRenderedCallbacks?: any = new EventEmitter();
  @Output() onQuickSearchChange?: any = new EventEmitter();
  @Output() onCopyRowItem?: any = new EventEmitter();
  @Output() onDeleteRows?: any = new EventEmitter();
  @Output() oninsertRows?: any = new EventEmitter();
  angularGrid: any;
  gridObj: any;
  dataViewObj: any;
  newRow = {};
  scrapDataSet: any[];
  gridCallbacks: object = {};
  quickFilter: string;
  screenHeight: any;
  screenWidth: any;
  moveRowsPlugin: any;
  filterText: string;
  @Output() visibleSidebar?: any = new EventEmitter();
  visibleFilter: boolean;

  constructor(private utils: Utils, private cdref: ChangeDetectorRef) { }

  getSelectedRowsIndex(scope) {
    const selectedRowsIndex = [];
    scope['gridObj'].getSelectedRows()
      .forEach((elem) => {
        selectedRowsIndex.push(elem);
      });
    return selectedRowsIndex;
  }

  getSelectedRows(scope) {
    const selectedRows = [];
    scope['gridObj'].getSelectedRows()
      .forEach((elem) => {
        const selectedItem = scope.getSelectedItem(elem, scope);
        if (selectedItem) {
          selectedItem.select = true;
          selectedRows.push(selectedItem);
        }
      });
    return selectedRows;
  }

  getSelectedItem(index: number, scope: object) {
    return scope['gridObj'].getData().getItem(index);
  }

  onCopyRow() {
    const selectedRows = this.getSelectedRowsIndex(this);
    if (!selectedRows || !selectedRows.length) {
      this.utils.showNotification('Please select atleast one row to clone.', 'info', 'Info Message');
    }
    selectedRows.forEach((elem) => {
      const selectedElem = Object.assign({}, this.getSelectedItem(elem, this));
      selectedElem.isCopiedRow = true;
      this.dataViewObj.addItem(selectedElem);
    });
    this.utils.insertIdFieldInDataSource(this.dataset, 'I');
    this.onCopyRowItem.emit(this.dataset);
  }

  clearRowSelections(scope) {
    if (scope && scope.gridObj && scope.gridObj.getSelectionModel()) {
      scope.gridObj.getSelectionModel().setSelectedRanges([]);
    }
  }

  onAddRow() {
    this.columnDefinitions.forEach((elem) => {
      const configs = elem.editor;
      if (configs) {
        let config = configs.params ? configs.params.configs : '';
        if (config) {
          config.model = '';
        }
      }
    });
    const dataset = this.dataset.slice(0);
    const rowCount = dataset.length;
    const newRow = { ...this.newRow };
    newRow['id'] = rowCount + 1;

    const selectedRowsIndex = this.getSelectedRowsIndex(this);
    if (this.gridOptions['canInsertRowInMiddle']) {
      const index = selectedRowsIndex.length ? selectedRowsIndex[0] : dataset.length;
      this.gridOptions['onAddRow'].call(this.gridOptions['scope'], newRow, dataset, index);
    } else {
      newRow['recStatus'] = 'I';
      newRow['validRow']=false;
      newRow['cueRowId'] = newRow['id'];
      this.dataViewObj.addItem({ ...newRow });
      if (this.gridOptions['onAddRow'] && !this.gridOptions['canInsertRowInMiddle']) {
        this.gridOptions['onAddRow'](this.gridOptions['scope']);
      }
    }
    this.oninsertRows.emit(newRow);

  }

  onDeleteRow(scope) {
    const deletedRows :any=[];
    let deletedRow={};

    scope = scope ? scope : this;
    const selectedRows = this.getSelectedRows(this);
    if (!selectedRows || !selectedRows.length) {
      this.utils.showNotification('Please select atleast one row to delete.', 'info', 'Info Message');
    }
    const key = this.gridOptions['id'] ? this.gridOptions['id'] : 'id';
    selectedRows.forEach((selectedItem) => {
      const index = this.dataset.findIndex((item) => {
        return item[key] === selectedItem[key];
      });
      deletedRow = selectedItem;
      deletedRow['recStatus'] = 'D';
      this.dataset.splice(index, 1);
      this.dataViewObj.refresh();
      deletedRows.push(deletedRow);

    });
    this.clearRowSelections(this);
    if (this.gridOptions['onDeleteRow']) {
      this.gridOptions['onDeleteRow'].call(this.gridOptions['scope'], selectedRows);
    }
    this.onDeleteRows.emit(deletedRows);
  }

  onFilterGrid(filterData: object, scope: object) {
    const filteredData = filterData && Object.keys(filterData);
    scope['dataset'] = JSON.parse(JSON.stringify(scope['scrapDataSet']));

    if (filteredData.length) {
      filteredData.forEach((elem) => {
        if (filterData[elem]) {
          if (filterData[elem] instanceof Date) {
            const date = moment(filterData[elem]).format(scope['gridOptions'].dateFormat);
            scope['dataset'] = scope['dataset'].filter(
              (element) => element[elem] === date);
            return;
          }

          if (typeof filterData[elem] === 'object') {
            if (!filterData[elem].id) { return; }
            scope['dataset'] = scope['dataset'].filter(
              (element) => element[elem] === filterData[elem].id);
            return;
          }

          scope['dataset'] = scope['dataset'].filter(
            (element) => element[elem] === filterData[elem]);
        }
      });
    }
  }

  angularGridReady(angularGrid: any) {
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid.slickGrid;
    this.dataViewObj = angularGrid.dataView;
    this.subscribeSelectionChangeEvent();
    this.subscribeCellClickEvent();
    this.onTableCreated.emit(this);
    this.createRowTemplate();
    this.clearRowSelections(this);
    this.setSelectedRows(this);
    this.onAfterRendered(this);
    this.quickFilter = this.gridOptions['showFilter'];
    this.visibleFilter = this.gridOptions['showAdvanceFilter'];

    const scope = this;
    this.dataViewObj.getItemMetadata = function (row) {
      const item = scope.dataViewObj.getItem(row);
      if (scope.gridOptions['isHighlightRow']) {
        const hightLightClass = scope.gridOptions['highlightConditions'].find(elem => {
          if (elem.isValueAvailableField && item[elem['hightLightKey']]) {
            return true;
          } else if (elem['condition'].toUpperCase() === (item[elem['hightLightKey']] && item[elem['hightLightKey']].toUpperCase())) {
            return true;
          }
        });
        return { cssClasses: hightLightClass ? hightLightClass.color : '' };
      } else {
        return { cssClasses: '' };
      }
    };

    // this.gridObj.setSelectionModel(this.angularGrid.pluginService._extensionList[4].instance);
    // this.moveRowsPlugin = new Slick.RowMoveManager({
    //   cancelEditOnDrag: true
    // });
    // this.angularGrid.pluginService.RowMoveManager();
    // this.angularGrid.slickGrid.registerPlugin(this.moveRowsPlugin);
  }

  onAfterEditCell($event) {
    // resume autoResize feature,  and after leaving cell editing mode
    // force a resize to make sure the grid fits the current dimensions
    this.angularGrid.resizerService.pauseResizer(false);
    this.angularGrid.resizerService.resizeGrid();
  }

  onBeforeEditCell($event) {
    this.angularGrid.resizerService.pauseResizer(true);
   if(this.callback['onBeforeEditCellChanges']!=null && this.callback['onBeforeEditCellChanges']!=undefined) {
   return this.callback['onBeforeEditCellChanges'] ($event);
   } 
  }

  resizeColumn(scope, isCollapse) {
    const columns = scope.gridObj.getColumns();
    const length = columns.length;
    if (isCollapse) {
      for (let i = 1; i < length; i++) {
        columns[i].minWidth += 100;
      }
    } else {
      for (let i = 1; i < length; i++) {
        columns[i].minWidth -= 100;
        columns[i].width -= 100;
        columns[i].widthRequest -= 20;
      }
    }
    scope.gridObj.setColumns(columns);
  }

  onAfterRendered(scope) {
    scope.dataViewObj.onRowsOrCountChanged.subscribe(
      (event) => {
        scope.afterViewRendered.emit(event);
      }
    )
    scope.afterGridRenderedCallbacks.emit(event);
  }

  setSelectedRows(scope) {
    let indices = [];
    const selectedRows = scope.gridOptions['selectedRows'];
    if (selectedRows && selectedRows.length) {
      selectedRows.forEach(element => {
        const index = scope.dataset.findIndex(elem => elem[scope.gridOptions['selectedRowKeyName']] === element);
        if (index > -1) {
          indices.push(index);
        }
      });
      if (indices && indices.length) {
        scope.gridObj.setSelectedRows(indices);
      }
      scope.gridObj.scrollRowIntoView((selectedRows[selectedRows.length - 1]), true);
    }
  }

  subscribeSelectionChangeEvent() {
    this.gridObj.onSelectedRowsChanged
      .subscribe((elem, selectedRowInfo) => {
        this.onSelectionChanges.emit({ rows: this.getSelectedRows(this), indexes: this.getSelectedRowsIndex(this), data: selectedRowInfo });
      });
  }

  selectedRowsIndex: number[] = [];
  subscribeCellClickEvent() {
    this.gridObj.onClick
      .subscribe((elem, selectedRowInfo) => {
        const rowDetails = {
          element: elem,
          selectedRowDetails: selectedRowInfo
        };
        this.onTableCellClicked.emit(rowDetails);
        this.selectedRowsIndex.push(selectedRowInfo.row);
      });
    if (this.gridOptions['doubleClick']) {
      this.gridObj.onDblClick
        .subscribe((elem, selectedRowInfo) => {
          const rowDetails = {
            element: elem,
            selectedRowDetails: selectedRowInfo
          };
          this.onTableRowDoubleClicked.emit(rowDetails);
          this.selectedRowsIndex.push(selectedRowInfo.row);
        });
    }
  }

  updateCellData(selectedRowItem, value, key, scope) {
    scope.dataViewObj.beginUpdate();
    scope.gridObj.invalidateRow();
    const selectedRow = scope.dataset[selectedRowItem.row];
    selectedRow[key] = value;
    scope.dataViewObj.updateItem(selectedRow[scope.gridOptions.idField], selectedRow);
    scope.dataViewObj.endUpdate();
  }

  groupByDuration() {
    this.dataViewObj.setGrouping({
      getter: this.gridOptions['groupField'],  // the column `field` to group by
      formatter: (g) => {
        // (required) what will be displayed on top of each group
        return `${g.value} <span style="color:green">(${g.count} items)</span>`;
      },
      aggregateCollapsed: false,  // (optional), do we want our aggregator to be collapsed?
      lazyTotalsCalculation: false // (optional), do we want to lazily calculate the totals? True is commonly used
    });
  }

  getData(query) {
    return query;
  }

  createRowTemplate() {
    if (this.dataset.length) {
      for (const elem in this.dataset[0]) {
        if (!this.newRow.hasOwnProperty(elem)) {
          this.newRow[elem] = '';
          this.newRow['recStatus'] = '';
        }
      }
    } else {
      const columns = this.gridObj.getColumns();
      columns.forEach((element, index) => {
        if (this.gridOptions.enableRowSelection && index > 0) {
          if (element.field) {
            this.newRow[element.field] = '';
          }
          this.newRow['recStatus'] = '';
        }
      });
    }
  }

  onDataviewCreated(event) {
    this.dataViewObj = event;
    this.onDataViewCreated.emit();
  }

  onGridCreated(event) {
    this.callback['GridData'] = event;
  }

  onCellClicked(eventData, args) {
    if (args.cell !== 0) {
    }
  }

  onCellChanged(e,a){
    console.log(a,e);
  }

  updateGrid(data: any, scope) {
    scope.dataViewObj.beginUpdate();
    scope.dataViewObj.setItems(data);
    scope.dataViewObj.endUpdate();
    scope.dataViewObj.refresh();
    scope.gridObj.invalidate();
    scope.clearRowSelections(scope);
  }

  updateRow(rowItem, scope) {
    scope.angularGrid.gridService.updateItem(rowItem);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.gridOptions.autoResize.maxHeight = this.screenHeight;
  }

  onShowSidebar(isVisible) {
    this.visibleSidebar.emit(isVisible);
  }

  ngOnInit() {
    this.callback['scope'] = this;
    this.callback['filterGrid'] = this.onFilterGrid;
    this.callback['getSelectedItems'] = this.getSelectedItem;
    this.callback['getSelectedRows'] = this.getSelectedRows;
    this.callback['updateCellData'] = this.updateCellData;
    this.callback['clearSelections'] = this.clearRowSelections;
    this.callback['updateGrid'] = this.updateGrid;
    this.callback['updateRow'] = this.updateRow;
    this.callback['resetGrid'] = this.resetGrid;
    this.callback['resizeColumn'] = this.resizeColumn;
    this.callback['setSelectedRows'] = this.setSelectedRows;

    // fill the dataset with your data
    // VERY IMPORTANT, Angular-Slickgrid uses Slickgrid DataView which REQUIRES a
    //  unique 'id' and it has to be lowercase 'id' and be part of the dataset
    this.utils.insertIdFieldInDataSource(this.dataset, this.gridOptions['recStatus']);
    this.scrapDataSet = JSON.parse(JSON.stringify(this.dataset));
    this.gridOptions.enableAutoTooltip = true;
    this.gridOptions.autoTooltipOptions = {
      /** are tooltip enabled for all cells? */
      enableForCells: true,

      /** are tooltip enabled for column headers */
      enableForHeaderCells: true,

      /** what is the maximum tooltip length in pixels (only type the number) */
      maxToolTipLength: 200,
    }
  }

  ngAfterViewInit() {
    if (!!this.gridOptions['groupField']) {
      this.groupByDuration();
    }
    this.onTableCreated.emit(this);
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  customFilter(item, args) {
    let isMatch = false;
    let obj: any = Object.values(item);
    for (var k in obj) {
      if (args["searchInput"] === "")
        return true;
      let value: string = obj[k];
      if (value) {
        value = value.toString();
        let matchedValue = value.toLowerCase().indexOf(args["searchInput"].toLowerCase());
        if (matchedValue > -1)
          return true;
      }
    }
    return isMatch;
  }

  resetGrid(scope) {
    scope.filterText = '';
    scope.dataViewObj.setFilterArgs({ searchInput: "" });
    scope.dataViewObj.setFilter(scope.customFilter);
    scope.clearRowSelections(scope);
  }

  SetfilterOnGrid(SearchPhrase) {
    let $parentElement = SearchPhrase.currentTarget.closest('.row');
    let inputValue = $parentElement.firstChild.firstChild.value;
    let columnFilters = { "searchInput": inputValue };
    const selectedRows = this.callback['getSelectedRows'](this.callback['scope']);
    this.gridOptions['selectedRows'] = this.utils.getSelectedRowsId(selectedRows, 'id');
    this.setSelectedRows(this);
    if (this.gridOptions['canOverRiderQuickSearch']) {
      this.onQuickSearchChange.emit(columnFilters);
      return;
    }
    this.dataViewObj.setFilterArgs(columnFilters);
    this.dataViewObj.setFilter(this.customFilter);
    this.dataViewObj.refresh();
    this.setSelectedRows(this);
    this.onQuickSearchChange.emit(this.dataViewObj.getFilteredItems());
  }

  customColumnFilter(filterFunction){
    this.dataViewObj.setFilter(filterFunction);
  }

  ngOnChanges(dataset: SimpleChanges) {
  }

  ngOnDestroy() {
    if (this.gridObj) {
      this.gridObj.onClick.unsubscribe();
      this.gridObj.onDblClick.unsubscribe();
      this.gridObj.onSelectedRowsChanged.unsubscribe();
    }
  }
}
